import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import SystemeLocationPerformanceOfferPage from "@/pages/SystemeLocationPerformanceOfferPage";
import SystemeLocationPerformancePage from "@/pages/SystemeLocationPerformancePage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/systeme-location-performance" element={<SystemeLocationPerformancePage />} />
        <Route path="/systeme-location-performance/offre" element={<SystemeLocationPerformanceOfferPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
